
import { createSlice } from '@reduxjs/toolkit';

const historiSlice = createSlice({
    name: 'history',
    initialState: {
        urls: []
    },
    reducers: {
        addUrl: (state, action) => {
            const i = state.urls.indexOf(action.payload);
            if (i !== -1) {
                state.urls.splice(i, 1);
            }
            state.urls.unshift(action.payload);
            if (state.urls.length > 12) {
                state.urls.pop();
            }

        },
        removeUrl: (state, action) => {
            state.urls.splice(action.payload, 1);
        },
        clearUrls: (state) => {
            state.urls = [];
        }
    }
});

export const { addUrl, removeUrl, clearUrls } = historiSlice.actions;
export default historiSlice.reducer;
